export const ADD_AIRPORT_REQUEST = "ADD_AIRPORT_REQUEST";
export const ADD_AIRPORT_SUCCESS = "ADD_AIRPORT_SUCCESS";
export const ADD_AIRPORT_FAILURE = "ADD_AIRPORT_FAILURE";
export const FETCH_AIRPORTS_REQUEST = "FETCH_AIRPORTS_REQUEST";
export const FETCH_AIRPORTS_SUCCESS = "FETCH_AIRPORTS_SUCCESS";
export const FETCH_AIRPORTS_FAILURE = "FETCH_AIRPORTS_FAILURE";
export const DELETE_AIRPORT_REQUEST = "DELETE_AIRPORT_REQUEST";
export const DELETE_AIRPORT_SUCCESS = "DELETE_AIRPORT_SUCCESS";
export const DELETE_AIRPORT_FAILURE = "DELETE_AIRPORT_FAILURE";
export const UPDATE_AIRPORT_REQUEST = "UPDATE_AIRPORT_REQUEST";
export const UPDATE_AIRPORT_SUCCESS = "UPDATE_AIRPORT_SUCCESS";
export const UPDATE_AIRPORT_FAILURE = "UPDATE_AIRPORT_FAILURE";
export const VIEW_AIRPORT_REQUEST = "VIEW_AIRPORT_REQUEST";
export const VIEW_AIRPORT_SUCCESS = "VIEW_AIRPORT_SUCCESS";
export const VIEW_AIRPORT_FAILURE = "VIEW_AIRPORT_FAILURE";
export const FETCH_ALL_AIRPORT_REQUEST = " FETCH_ALL_AIRPORT_REQUEST";
export const FETCH_ALL_AIRPORT_SUCCESS = "FETCH_ALL_AIRPORT_SUCCESS";
export const FETCH_ALL_AIRPORT_FAILURE = "FETCH_ALL_AIRPORT_FAILURE";
export const UPDATE_AIRPORT_APPROVAL_STATUS_REQUEST =
  "UPDATE_AIRPORT_APPROVAL_STATUS_REQUEST";
export const UPDATE_AIRPORT_APPROVAL_STATUS_SUCCESS =
  "UPDATE_AIRPORT_APPROVAL_STATUS_SUCCESS";
export const UPDATE_AIRPORT_APPROVAL_STATUS_FAILURE =
  "UPDATE_AIRPORT_APPROVAL_STATUS_FAILURE";
export const RESET_AIRPORT_STATE = "RESET_AIRPORT_STATE";

export const APPROVE_AIRPORT_UPDATE_REQUEST = "APPROVE_AIRPORT_UPDATE_REQUEST";
export const APPROVE_AIRPORT_UPDATE_SUCCESS = "APPROVE_AIRPORT_UPDATE_SUCCESS";
export const APPROVE_AIRPORT_UPDATE_FAILURE = "APPROVE_AIRPORT_UPDATE_FAILURE";
